import { render, staticRenderFns } from "./warehouseLabel100x40.vue?vue&type=template&id=0b0f3c31&scoped=true&"
import script from "./warehouseLabel100x40.vue?vue&type=script&lang=js&"
export * from "./warehouseLabel100x40.vue?vue&type=script&lang=js&"
import style0 from "./warehouseLabel100x40.vue?vue&type=style&index=0&id=0b0f3c31&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0f3c31",
  null
  
)

export default component.exports